"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RadioGroup_1 = require("./RadioGroup");
exports.default = RadioGroup_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/RadioGroup/index.js
// module id = 592
// module chunks = 8